<template>
  <div class="index-bg">
    <div class="index-header">
      <img class="logo" src="../../../assets/img/logo.png" />
      <div class="search-cont" @click="searchPage">
        <van-icon name="sousuo"></van-icon><span>搜索职位/公司…</span>
      </div>
      <van-icon class="history" name="lishi" @click="applicationRecord"
        ><span>申请记录</span></van-icon
      >
    </div>
    <van-swipe class="swipe" :autoplay="5000" indicator-color="white">
      <van-swipe-item v-for="item in banner" :key="item.id">
        <img v-if="item.image" :src="item.image" />
      </van-swipe-item>
    </van-swipe>
    <div class="title-01">
      <h2>推荐企业</h2>
      <router-link class="btn-more" :to="{ name: 'companyList' }"
        >全部企业</router-link
      >
    </div>
    <!-- <ul class="company-list">
      <li
        v-for="item in company"
        :key="item.index"
        @click="companyDetail(item.id)"
      >
        <img v-if="item.enterpriseLogoUrl" :src="item.enterpriseLogoUrl" />
        <div class="detail-info">
          <h3>{{ item.enterpriseName }}</h3>
          <ul class="feature">
            <li>{{ item.enterpriseTypeName }}</li>
            <li>{{ item.personnelSize }}</li>
            <li>{{ item.enterpriseTradesName }}</li>
          </ul>
          <ul class="welfare">
            <li v-for="welfare in item.welfarelist" :key="welfare.index">
              {{ welfare.detail }}
            </li>
          </ul>
          <div class="jobs">
            在招职位 <span>{{ item.positionCnt }}</span>
          </div>
        </div>
      </li>
    </ul> -->
    <ul class="company-list-simple">
      <li
        v-for="item in companySimple"
        :key="item.index"
        @click="companyDetail(item.id)"
      >
        <img v-if="item.enterpriseLogoUrl" :src="item.enterpriseLogoUrl + '?imageMogr2/auto-orient/thumbnail/100x100'" />
        <div class="detail-info">
          <h3>{{ item.enterpriseName }}</h3>
          <ul class="feature">
            <li>{{ item.enterpriseTypeName }}</li>
            <li>{{ item.personnelSize }}</li>
            <li>{{ item.enterpriseTradesName }}</li>
          </ul>
        </div>
      </li>
    </ul>
    <div class="gray-blank"></div>
    <div class="title-01">
      <h2>急招职位</h2>
      <router-link class="icon-more" :to="{ name: 'jobList' }"
        >更多 <van-icon name="gengduo"></van-icon
      ></router-link>
    </div>
    <ul class="job-list">
      <li v-for="item in jobs" :key="item.index" @click="jobDetail(item.id)">
        <div class="detail-info">
          <div class="info-header">
            <h3>{{ item.jobName }} <small>急</small></h3>
            <span>{{ item.salary }}</span>
          </div>
          <ul class="conditionList">
            <li v-text="item.expLevel"></li>
            <li v-text="item.eduLevel"></li>
          </ul>
          <ul class="feature">
            <li v-text="item.enterpriseName"></li>
            <li v-text="item.personnelSize"></li>
          </ul>
        </div>
      </li>
    </ul>
    <!--<van-popup v-model="popup" closeable>-->
    <!--<div class="pop-cont">-->
    <!--<img src="@assets/img/popbg.png" />-->
    <!--<p>你离心仪的职位只差一份简历</p>-->
    <!--<router-link :to="{ name: 'basicInfo' }">-->
    <!--<van-button-->
    <!--type="primary"-->
    <!--color="linear-gradient(to right top, #F69B58,#F87342)"-->
    <!--round-->
    <!--&gt;创建简历</van-button-->
    <!--&gt;-->
    <!--</router-link>-->
    <!--</div>-->
    <!--</van-popup>-->
    <!--<create-resume-dialog ref="resumeDialog"></create-resume-dialog>-->
    <navBar ref="navBarObject"></navBar>
  </div>
</template>

<script>
import navBar from './components/navbar'
// import createResumeDialog from './components/createResumeDialog'
import native from '@utils/native'
import { throttle } from "@utils/index";
export default {
  name: 'index',
  components: {
    navBar
    // createResumeDialog
  },
  data() {
    return {
      value: '',
      // popup: false,
      banner: [],
      company: [],
      companySimple: [],
      jobs: []
    }
  },
  methods: {
    httpData() {
      const params = {
        adClientType: '1',
        adPositionName: 'home-banner',
        size: 5
      }
      this.module.api.adList({
        params: params,
        success: ({ records }) => {
          this.banner = records
        }
      })
      // this.module.api.entList({
      //   params: {
      //     recommend: 1,
      //     size: 3
      //   },
      //   success: ({ records }) => {
      //     this.company = records
      //   }
      // })
      this.module.api.entList({
        params: { recommend: 1, size: 10 },
        success: ({ records }) => {
          this.companySimple = records
        }
      })
      $$.module.api.posList({
        data: { urgent: 1, size: 20 },
        success: ({ records }) => {
          this.jobs = records
        }
      })
      // this.$http({
      //   url: "/wdjob-api/pos/list",
      //   method: "get",
      //   data: this.$http.adornParams({
      //     urgent: true
      //   })
      // }).then(({ status, data: { data: { records } } }) => {
      //   if (status === 200) {
      //     this.jobs = records;
      //   }
      // });
    },
    applicationRecord:throttle(function(){
      let rtnVal = native.shmedia2.isRmtNative()
      console.log(rtnVal)
      if (rtnVal === 40) {
        // 由于延时未调用查询简历接口
        this.module.api.hasResume({
          params: {},
          success: data => {
            console.log(data)
            this.$cookie.set('hasResume', data)
            if (data === true) {
              // 已有简历
              this.$router.push({ name: 'applicationRecord' })
            } else {
              // 无简历
              this.showCreateResumeDia()
            }
          }
        })
      } else if (rtnVal === 10) {
        // 已登录已创建简历
        this.$router.push({ name: 'applicationRecord' })
      } else if (rtnVal === 0) {
        // 端外
        window.AppSiteConfig.showDownDialog()
      } else if (rtnVal === 20) {
        // 登录了没有创建简历的情况
        console.log('show popup')
        this.showCreateResumeDia()
      }
    },1000),
    companyDetail(id) {
      this.$router.push({ name: 'companyDetail', query: { id } })
    },
    jobDetail(id) {
      this.$router.push({ name: 'jobDetail', query: { id } })
    },
    searchPage: function() {
      this.$router.push({ name: 'searchJob' })
    },
    showCreateResumeDia() {
      // this.$refs.resumeDialog.isShowDia();
      this.$refs.navBarObject.showCreateResumeDia()
    }
  },
  created() {
    // 更新用户Token
    native.shmedia2.getToken()

    if (this.$cookie.get('token')) {
      this.module.api.hasResume({
        params: {},
        success: data => {
          console.log(data)
          this.$cookie.set('hasResume', data)
        }
      })
    }

    // 初始化数据
    this.httpData()
  }
}
</script>

<style lang="less" scoped>
  .title-01{
    margin-bottom: 26px;
  }
.index-bg {
  background: url("../../../assets/img/indexbg.png") center top no-repeat;
  background-size: 100% auto;
  padding: 10px 0;
}
/deep/.swipe {
  margin: 8px 18px;
  height: 200px;
  img {
    width: 100%;
    border-radius: 10px;
  }
}
.index-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  .logo {
    width: 104px;
    height: 24px;
  }
  .search-cont {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #fff;
    height: 30px;
    border-radius: 50px;
    background: rgba(255, 255, 255, 0.3);
    flex: 1;
    margin: 0 16px;
    span {
      font-size: 12px;
      margin-left: 10px;
    }
  }
  .history {
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-top: -4px;
    span {
      font-size: 12px;
      display: block;
      line-height: 1;
      transform: scale(0.9);
    }
  }
}
.detail-info {
  width: 100%;
  overflow: hidden;
  .feature {
    li:last-child {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
// img {
//   object-fit: fill;
//   image-rendering: -moz-crisp-edges; /* Firefox */
//   image-rendering: -o-crisp-edges; /* Opera */
//   image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
//   image-rendering: crisp-edges;
//   -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
// }
</style>
